module.exports = __webpack_public_path__ + "img/gsb22.1ad6b703.png";